/* eslint-disable react-hooks/exhaustive-deps */
import './GameStyling.css';
import React, { useEffect, useRef, useState } from 'react';

export function EasterEggGame() {
	const playerRef = useRef<HTMLDivElement>(null);
	const enemyRef = useRef(null);
	const enemyTwoRef = useRef(null);
	const [score, setScore] = useState(0);
	const [earlierScore, setEarlierScore] = useState(Number);
	const [highScore, setHighScore] = useState(0);
	const [isCounting, setIsCounting] = useState(false);
	const [gameOver, setGameOver] = useState(false);
	const [startGame, setStartGame] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [thirdPhase, setThirdPhase] = useState(false);

	const jumpAction = (ev: KeyboardEvent) => {
		if (['q', 'w', 'e'].includes(ev.key.toLowerCase())) {
			const player = playerRef.current;
			if (player && !player.classList.contains('jump')) {
				player.classList.add('jump');

				setTimeout(() => {
					player.classList.remove('jump');
				}, 600);
			}
		}
	};

	const scoreAction = () => (
		<div>
			<p>
				High score: {highScore}, Score: {score}
			</p>
		</div>
	);

	const startAction = () => {
		setStartGame(true);
		setIsCounting(true);
		setScore(0);
		setEarlierScore(0);
		setGameOver(false);
		setShowAlert(false);
	};

	const deathAction = () => {
		setThirdPhase(false);
		setIsCounting(false);
		setEarlierScore(score);
		if (score > highScore) {
			setHighScore(score);
		}
		setGameOver(true);
		setShowAlert(true);
	};

	// Timer
	useEffect(() => {
		let interval: NodeJS.Timeout;
		if (isCounting && startGame) {
			interval = setInterval(() => {
				setScore((prevScore) => prevScore + 1);
			}, 1000);
		}

		// Cleanup interval on component unmount
		return () => clearInterval(interval);
	}, [isCounting, startGame]);

	// Collision detection
	useEffect(() => {
		const player = playerRef.current;
		const enemy = enemyRef.current;
		const enemyTwo = enemyTwoRef.current;

		const isAlive = setInterval(() => {
			if (player && enemy && startGame && enemyTwo) {
				// Get the player current y position
				let playerTop = parseInt(window.getComputedStyle(player).getPropertyValue('top'));

				// Get the enemy current x position
				let enemyLeft = parseInt(window.getComputedStyle(enemy).getPropertyValue('left'));
				// Get the second enemy current x position
				let enemyTwoLeft = parseInt(window.getComputedStyle(enemyTwo).getPropertyValue('left'));

				// Detect collisions and setting game state's
				if (enemyLeft < 20 && enemyLeft > -15 && playerTop >= 135) {
					deathAction();
				}

				if (enemyTwoLeft < 20 && enemyTwoLeft > -15 && playerTop >= 135) {
					deathAction();
				}

				if (score > 50 && score < 70 && !thirdPhase) {
					setThirdPhase(true);
				}
			}
		}, 10);

		if (startGame) {
			window.addEventListener('keydown', jumpAction);
		}

		// Cleanup on unmount
		return () => {
			clearInterval(isAlive);
			window.removeEventListener('keydown', jumpAction);
		};
	}, [score, highScore, startGame, thirdPhase, deathAction]);

	// Handle restart
	useEffect(() => {
		const restartBtn = document.getElementById('restartBtn');

		const handleRestart = () => {
			startAction();
		};

		if (restartBtn) {
			restartBtn.addEventListener('click', handleRestart);
		}

		// Cleanup event listener on unmount
		return () => {
			if (restartBtn) {
				restartBtn.removeEventListener('click', handleRestart);
			}
		};
	}, []);

	function enemyAnimationSwitch() {
		let className;
		switch (true) {
			case !startGame || gameOver:
				className = 'start';
				break;
			case score > 2 && score < 50:
				className = 'difficultyTwo';
				break;
			case score > 50 && score < 70:
				className = 'difficultyThree';
				break;
			case score > 70:
				className = 'difficultyFour';
				break;
			default:
				className = 'l';
		}
		return className;
	}

	return (
		<div className="main">
			{!startGame && (
				<div id="startScreen" className="start-screen">
					<h1>Welcome</h1>
					<p> Here is a mini easter egg game to rest your head.</p>
					<p> To play use Q, W and E.</p>
					<button onClick={startAction}>Start Game</button>
				</div>
			)}
			<div className="game">
				<div id="player" className={!startGame || gameOver ? 'start' : ''} ref={playerRef}></div>
				<div id="enemy" className={enemyAnimationSwitch()} ref={enemyRef}></div>
				<div id="enemyTwo" className={thirdPhase ? 'difficultyThree' : ''} ref={enemyTwoRef}></div>
				<div id="background" className={!startGame || gameOver ? 'start' : ''}></div>
			</div>
			<div id="score">{scoreAction()}</div>

			<div id="customAlert" className={showAlert ? 'show' : ''}>
				<div className="alert-content">
					<p>You crashed into a factory!</p>
					<p>Your score was: {earlierScore}</p>
					<button id="restartBtn">Restart</button>
				</div>
			</div>
		</div>
	);
}

export default EasterEggGame;
